import { render, staticRenderFns } from "./ecenter-table.vue?vue&type=template&id=32ac4575&"
import script from "./ecenter-table.vue?vue&type=script&lang=js&"
export * from "./ecenter-table.vue?vue&type=script&lang=js&"
import style0 from "./ecenter-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports